export const Linking9035 = `
... on Form9141DataDatahub {
    caseNumber
    pwdWageRate
    pwdUnitOfPay
}
`;
